import axios from './axios'

export const createValuationDate = ({ data }) => axios.post('valuation_dates', data)
export const deleteValuationDate = ({ id }) => axios.delete(`valuation_dates/${id}`)
export const findValuationDate = ({ id, params } = {}) => axios.get(`valuation_dates/${id}`, { params })
export const getValuationDates = ({ params } = {}) => axios.get('valuation_dates', { params })
export const updateValuationDate = ({ id, data }) => axios.put(`valuation_dates/${id}`, data)
